// @flow
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useI18n, withI18n } from '@shopify/react-i18n';
import _ from 'lodash';

import { Badge, Icon, Link } from '@shopify/polaris';
import * as AppIntegrationActions from 'actions/app-integration-actions';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';
import { ExternalMinor } from '@shopify/polaris-icons';

type IProps = {
  index: number,
  data: IntegrationData
};

type IntegrationData = {
  icon: string,
  name: string,
  appName?: string,
  appType?: string,
  integration?: string,
  appListingURL: string,
  description: string,
  instructionURL: string,
  iconStyle?: React.CSSProperties
};

const IntegrationWishlistCard: React.FC<IProps> = ({ index, data }) => {
  const [i18n] = useI18n();
  const dispatch = useDispatch();

  const currentAppIntegration = useSelector(state =>
    _.get(state.oauth.tenantApp, 'currentAppIntegration', {})
  );

  const tenantApp = useSelector(state => _.get(state.oauth, 'tenantApp', {}));
  const isEnableShopifyIntegration = enableShopifyIntegration(tenantApp);

  const {
    icon,
    name,
    appName,
    appType,
    // integration,
    appListingURL,
    description,
    instructionURL,
    iconStyle,
    autoIntegration = false
  } = data || {};

  const handleChange = useCallback(
    (appTypeParam, appNameParam) => {
      dispatch(
        AppIntegrationActions.handleChangeApp(currentAppIntegration, appTypeParam, appNameParam)
      );
    },
    [dispatch, currentAppIntegration]
  );

  return (
    <div className={index === 1 ? 'item middle' : 'item'} key={`item-${index}`}>
      <div className="item-header">
        <a className="Polaris-Link" href={appListingURL} target="_blank" rel="noopener noreferrer">
          <img
            className="icon"
            src={icon}
            alt={i18n.translate(name)}
            style={iconStyle ? iconStyle : {}}
          />
        </a>
      </div>
      {/* App name */}
      <div className="name">{i18n.translate(name)}</div>

      {/* App description */}
      <div className="description">{i18n.translate(description)}</div>

      {/*Enable/Disable app key*/}
      {isEnableShopifyIntegration && (
        <div className="BC-Checkbox-Status__Wrapper">
          <div className="integration">
            <Badge status="info">
              <Link url={instructionURL} external>
                {i18n.translate('AdminHTML.Integration.Constants.integrationGuide')}
                <Icon source={ExternalMinor} />
              </Link>
            </Badge>
          </div>

          {autoIntegration ? (
            <label className="BC-Checkbox-Status">
              <input
                type="checkbox"
                checked={currentAppIntegration[appType] === appName}
                onChange={() => handleChange(appType, appName)}
              />
              <span />
            </label>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default withI18n()(IntegrationWishlistCard);
